import { render, staticRenderFns } from "@/templates/bookings/bookingConfirmed.html?vue&type=template&id=b66a6ca0&scoped=true&"
import script from "./BookingConfirmed.vue?vue&type=script&lang=js&"
export * from "./BookingConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./BookingConfirmed.vue?vue&type=style&index=0&id=b66a6ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66a6ca0",
  null
  
)

export default component.exports